export const TipoErroCadastroEnum = {
  RECUPERAR_SENHA: 'RECUPERAR_SENHA',
  ATENDIMENTO: 'ATENDIMENTO',
  USUARIO_NAO_CADASTRADO: 'USUARIO_NAO_CADASTRADO'
};
